import { ClientLambdaApi } from '@/api-client.js'

const getClientProducts = async ({ sortBy = null, sortDir = null, search = null, page = 1, pageSize = 50 } = {}) => {
  const params = new URLSearchParams()
  params.set('page', page)
  params.set('pageSize', pageSize)
  if (sortBy) params.set('sortBy', sortBy)
  if (sortDir) params.set('sortDir', sortDir)
  if (search) params.set('search', search)
  const clientProducts = await ClientLambdaApi.get(`/product-master/detail/client-products?${params.toString()}`)
  return clientProducts.data
}

const getProductMap = async (retailId, { sortBy = null, sortDir = null, search = null, page = 1, pageSize = 50 } = {}) => {
  const params = new URLSearchParams()
  params.set('page', page)
  params.set('pageSize', pageSize)
  if (sortBy) params.set('sortBy', sortBy)
  if (sortDir) params.set('sortDir', sortDir)
  if (search) params.set('search', search)
  const productMap = await ClientLambdaApi.get(`/product-master/detail/product-map/${retailId}?${params.toString()}`)
  return productMap.data
}

const getKeyMetrics = async () => {
  const keyMetrics = await ClientLambdaApi.get('/product-master/key-metrics')
  return keyMetrics.data
}

const updateProductMap = async (productMapId, productId) => {
  await ClientLambdaApi.patch('/product-master/product-map', {
    productMapId: productMapId,
    productId: productId
  })
}

const searchProducts = async (searchQuery) => {
  const searchProducts = await ClientLambdaApi.get(`/product-master/client-products/search?searchQuery=${searchQuery}`)
  return searchProducts.data
}

const getProductMapSuggestions = async (searchQuery) => {
  const searchParams = encodeURIComponent(searchQuery)
  const searchProducts = await ClientLambdaApi.get(`product-master/product-map/search-suggestion?searchDescription=${searchParams}`)
  return searchProducts.data
}

export {
  getClientProducts,
  getProductMap,
  getKeyMetrics,
  updateProductMap,
  searchProducts,
  getProductMapSuggestions
}



// WEBPACK FOOTER //
// ./src/app/product_master/Services.js